import { createAsyncThunk } from '@reduxjs/toolkit';
import { TSyncAdditionalInfoResponse, TTaxResidencyPrefillResponse } from '../types';
import { thunkErrorHandler } from '~/store/utils';
import { TTaxResidencyAdditionalInformation } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/types';
import api from '~/libs/api';

export const updateAdditionalInformation = createAsyncThunk<
  TSyncAdditionalInfoResponse,
  { applicationId: number | string }
>('identification/updateAdditionalInfo', async ({ applicationId }, { rejectWithValue }) => {
  try {
    const { data: response } = await api.post(
      `identification/application/${applicationId}/ownership-structure/sync-additional-information`
    );
    return response;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const taxResidencyAdditionalInfoPrefill = createAsyncThunk<
  TTaxResidencyPrefillResponse,
  { applicationId: number | string; formId: number | string }
>(
  'identification/taxResidencyAdditionalInfoPrefill',
  async ({ applicationId, formId }, { rejectWithValue }) => {
    try {
      const { data: response } = await api.post(
        `/identification/screen-forms/application/${applicationId}/tax-residency-additional-info/${formId}/prefill`
      );
      return response;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const taxResidencyAdditionalInfoDelete = createAsyncThunk<
  TTaxResidencyAdditionalInformation,
  { applicationId: number | string }
>(
  'identification/taxResidencyAdditionalInfoDelete',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const { data: response } = await api.delete(
        `/identification/screen-forms/application/${applicationId}/tax-residency-additional-info/delete`
      );
      return response;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
